module.exports = __webpack_public_path__ + "static/media/moonpig.3dab1e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/moonpig.jpg
// module id = 47
// module chunks = 0